import { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";

import "./Suggestion.scss";

import { useChatService } from "../../../../services/ServiceHooks";

interface ISuggestionProps {
  intro: string;
  details: string;
  selectSuggestion: (suggestion: string) => void;
  id?: string;
}

const RawSuggestion: FunctionComponent<ISuggestionProps> = ({
  intro,
  details,
  selectSuggestion,
  id,
}: ISuggestionProps) => {
  return (
    <button
      className="suggestion-component"
      data-testid={id ?? "suggestion-button"}
      onClick={() => selectSuggestion(`${intro} ${details}`)}
      type="button"
      tabIndex={0}
      role="button"
    >
      <span className="suggestion-intro">{intro}</span>
      <span className="suggestion-details">{details}</span>
    </button>
  );
};

export const Suggestion = observer(RawSuggestion);
